import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Fieldlinks } from '../../core/entities/fieldlinks.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FieldlinksService {
    readonly BASE: any = PETICIONES.fieldlinks;

    constructor(private http: HttpClient) { }

  /**
   * @description
   * Obtiene todos los fieldlinks
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un fieldlinks por su id
   */
  public findById(id: number): Observable<any> {
    let idFieldlinks: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idFieldlinks).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un fieldlinks en la base de datos
   */
  public postFieldlink(fieldlinks: Fieldlinks): Observable<any> {
    const json = JSON.stringify(fieldlinks);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postFieldlinks, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un fieldlinks en la base de datos
   */
  public deleteFieldlink(fieldlinks: Fieldlinks): Observable<any> {
    let idfieldlinks: string = (fieldlinks.id !== undefined && fieldlinks.id !== null ? fieldlinks.id + "" : "");
    return this.http.get(this.BASE.deleteFieldlinks + "/" + idfieldlinks).pipe(delay(DELAY));
  }

}